module.exports = __webpack_public_path__ + "static/media/camera.2e142820.svg";